export enum Page {
    CustomerList = 0
    , ProductList = 1
    , OrderList = 2
    , TransactionHistList = 3
    , OrderStatusList = 4
    , UserProfile = 5
    , CustomerSearchPage = 6
}


// WEBPACK FOOTER //
// ./src/enums/page.enum.ts